// libraries
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import OutlinedButton from "../../../components/common/OutlinedButton";
import PrimaryButton from "../../../components/common/PrimaryButton";
import { ROUTES } from "../../../setup/constants";
// components
import { BUTTONS } from "./constants";
// styles
import styles from "./contractNotFound.module.scss";

const ContractNotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onHomeClick = () => {
    navigate(`${ROUTES.HOME}`);
  };
  return (
    <div className={classNames(styles.container, "pageLayout")}>
      <div className={styles.wrapper}>
        <div className={styles.wrapper_container}>
          <div>
            <img alt="complex" src="/assets/images/svg/notFound.svg" />
          </div>
          <div className={styles.text_wrapper}>
            <h1>{t("lbl_contract_details_empty_view_title")}</h1>
            <p className={"p1"}>{t("lbl_description_connect with_seller")}</p>
          </div>
          <div className={styles.button_container}>
            <PrimaryButton onClick={() => onHomeClick()}>
              {BUTTONS.CREATE_CONTRACT}
            </PrimaryButton>
          </div>
          <div className={styles.button_container}>
            <OutlinedButton onClick={() => onHomeClick()}>
              <p className={classNames("subtitle2", "primary")}>
                {t("lbl_empty_contract_details_btn_back_to_home")}
              </p>
            </OutlinedButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractNotFound;
